import ClipboardCheckIcon from '@heroicons/react/outline/ClipboardCheckIcon'

import { Post, PostStatus } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import type { StaticField } from '../../Views/types'
import { Field } from './Field'

interface Props {
  post: Post
  fields: StaticField[]
  preview: boolean
  activeFieldId: string
  isSinglePost?: boolean
}
export const PostsCardItem = ({
  post,
  fields,
  preview,
  activeFieldId,
  isSinglePost,
}: Props) => {
  const {
    data: { postTypes },
  } = useNetwork()
  const bannerField = fields.find(field => field.id === 'cardBanner')
  const replyListField = fields.find(field => field.id === 'replyList')
  const isPendingReview = post.status === PostStatus.BLOCKED
  return (
    <>
      <Card padding="md" className="overflow-hidden">
        {isPendingReview && (
          <Card.Header>
            <Alert
              status="neutral"
              className="rounded-b-none"
              icon={<ClipboardCheckIcon />}
            >
              <T
                id="Generics.PendingReviewBanner"
                defaultMessage="This post is pending for approval. Once it's approved, it'll be available to other members."
              />
            </Alert>
          </Card.Header>
        )}
        {!!bannerField && (
          <Card.Media>
            <Field
              key={bannerField.id}
              field={bannerField}
              post={post}
              activeFieldId={activeFieldId}
              postTypes={postTypes}
              viewStyle="card"
              preview={preview}
              isSinglePost={isSinglePost}
            />
          </Card.Media>
        )}
        <Card.Content>
          <div className="flex flex-wrap gap-4 items-center">
            {fields
              .filter(field => !['cardBanner', 'replyList'].includes(field.id))
              .map(field => (
                <Field
                  key={field.id}
                  field={field}
                  post={post}
                  activeFieldId={activeFieldId}
                  postTypes={postTypes}
                  viewStyle="card"
                  preview={preview}
                  isSinglePost={isSinglePost}
                />
              ))}
          </div>
        </Card.Content>
        {!!replyListField && !isSinglePost && (
          <Field
            key={replyListField.id}
            field={replyListField}
            post={post}
            activeFieldId={activeFieldId}
            postTypes={postTypes}
            viewStyle="card"
            preview={preview}
            isSinglePost={isSinglePost}
          />
        )}
      </Card>
      {!!replyListField && isSinglePost && (
        <Field
          key={replyListField.id}
          field={replyListField}
          post={post}
          activeFieldId={activeFieldId}
          postTypes={postTypes}
          viewStyle="card"
          preview={preview}
          isSinglePost={isSinglePost}
        />
      )}
    </>
  )
}
